export const metatags = {
    main: {
        title: "Ana Sayfa - Misli TV",
    },
    live: {
        slug: "canli-bahisler",
    },
    matchDetail: {
        slug: "mac-detay",
    },
    liveResults: {
        slug: "canli-sonuclar",
    },
    matchResults: {
        slug: "mac-sonuclari",
    },
    fixture: {
        slug: "yaklasan-maclar",
    },
    generalSettings: {
        slug: "genel-ayarlar",
    },
    multipleScreens: {
        slug: "coklu-ekran",
    },
    multipleScreensSingle: {
        slug: "tekli-ekran",
    },
    multipleScreensDetail: {
        slug: "tekli-coklu-ekran-detay",
    },
    keno: {
        slug: "keno",
    },
};
